import React from 'react'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import makeStyles from '@material-ui/core/styles/makeStyles';
import RouteLinkComponent from './RouteLinkComponent';
import { classNames } from '../functions/classNames';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { ROUTES } from '../constants/routes';

const useStyles = (size, widthSize, name) => makeStyles((theme) => ({
    secondaryItems: {
        opacity: 0,
        background: theme.palette.secondary.main,
        zIndex: 4,
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
        transition: 'all 0.15s ease-in',
        paddingTop: 4,
        position: "absolute",
        top: 0,
        left: '100%'
    },
    root: {
        width: widthSize,
    },

    primary: {
        fontSize: size,
        cursor: 'pointer',
        fontFamily: theme.typography.fontFamily,
        color: `${theme.palette.secondary.orange} !important`,
        fontWeight: 550,
        position: 'relative',
        display: 'inline-block',
        '&::before': {
            content: `"${name}"`,
            color: theme.palette.primary.main,
            position: 'absolute',
            transition: 'transform 0.3s, opacity 0.3s;',
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            height: '3px',
            background: theme.palette.secondary.orange,
            opacity: '0',
            transform: 'translateY(5px)',
            transition: 'transform 0.3s, opacity 0.3s'
        },
        '&:hover': {
            color: theme.palette.secondary.orange,
            textShadow: 'none',
            '&::before': {
                opacity: '0',
                transform: 'translateY(-2px)',
            },
            '&::after': {
                opacity: '1',
                transform: 'translateY(0px)',
            },
        },
    },
    back: {
        fontSize: 12,
        textTransform: 'uppercase',
        cursor: 'pointer',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.primary.main,
        fontWeight: 550,
    },
    item: {
        width: 320,
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            position: 'initial',
        },
        [theme.breakpoints.up('lg')]: {
            '&:hover>.hoverEffect': {
                display: "block",
                opacity: 1,
            },
        },
    },
    showSubMenu: {
        opacity: 1,
        left: 0,
        width: '100vw',
        height: '100%',
        background: theme.palette.secondary.main,
        zIndex: 1,
        top: 0,
    },
    backIcon: {
        minWidth: 20
    },
    backItem: {
        marginLeft: -15,
        cursor: 'pointer'
    },
    itemIcon: {
        cursor: 'pointer'
    },
    activeLink: {
        color: theme.palette.secondary.orange,
        textShadow: 'none',
        '&::before': {
            opacity: '0',
            transform: 'translateY(-2px)',
        },
        '&::after': {
            opacity: '1',
            transform: 'translateY(0px)',
        },
    }
}))

const SideMenuItemComponent = ({ handleClose = () => {}, title, items, size = 28, widthSize = 320, externalLink, pageLink, slug = '#' }) => {
    const classes = useStyles(size, widthSize, title)();
    const history = useHistory();

    const isActive = useMemo(() => {
        const pathname = history?.location?.pathname;
        return pageLink
            ? pathname === `/${ROUTES['page']}/${slug}`
            : pathname === `/${slug}`

    }, [slug, pageLink, history])
    return (
        <ListItem className={classes.item} onClick={handleClose}>
            <RouteLinkComponent
                to={externalLink ? false : `${pageLink ? ROUTES['page'] : ''}/${slug}`}
                href={externalLink ? slug : false}
            >
                <ListItemText
                    primary=
                    {title}
                    classes={{
                        root: classes.root,
                        primary: classNames([classes.primary, isActive ? classes.activeLink : ''])
                    }} />
            </RouteLinkComponent>
        </ListItem>
    )
}


export default React.memo(SideMenuItemComponent);